import axios from 'axios';
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import './productDetail.css';
import { ImTruck } from 'react-icons/im'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { useContext } from 'react';
import { DataContext } from '../../Context';

function ProductDetails({ addToCart }) {
  let { id } = useParams();
  const baseURLProducto = `https://72jjtpdj.directus.app/items/productos?fields=id,nombre,imagen,precio,descripcion,descuento,stock&filter[id]=${id}`;
  const history = useHistory();
  const baseImage = "https://72jjtpdj.directus.app/assets/";
  const [producto, setProducto] = useState([]);
  const {precioValue, errorDolarAPI} = useContext(DataContext)
  React.useEffect(() => {
    axios.get(baseURLProducto).then((response) => {
      setProducto(response.data.data);
    });


  }, [])

  const crearProducto = (nombre, descuento, imagen, id, precio) => {
    let productItem = {
      imagen: imagen,
      descuento: descuento,
      id: id,
      nombre: nombre,
      precio: precio
    }
    addToCart(productItem);
  }

  return (
    <>
      <div className="product_detail_container">
        {
          producto.map(item => {
            return (
              <div key={item.id} className='productdetail_item'>
                <section>
                  <Zoom className="zoom_container">
                    <div className="imageleft_productdetail">
                      <img src={baseImage + item.imagen} alt={item.nombre} />
                    </div>
                  </Zoom>
                  <div className="info_productdetail_container">
                    <h1>{item.nombre}</h1>
                    <div className='priceAndDiscount'>
                      <div className="beforePrice">
                        {item.descuento > 0 ? <h4>Antes: <strike> {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(precioValue * item.precio)}</strike></h4> : null}
                      </div>
                      <div className='priceAndOff'>
                        {item.descuento > 0 ? <h4 className='prueba'> {Intl.NumberFormat('de-DE').format(parseInt(precioValue * item.precio) - (parseInt(item.descuento) * parseInt(precioValue * item.precio) / 100))} {errorDolarAPI ? "USD" : "AR$"} </h4> : <h4 className='prueba'> {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(precioValue * item.precio)}</h4>}
                        <h4 className="Discount">{(item.descuento > 0) ? item.descuento + " % OFF" : null}</h4>
                      </div>
                    </div>
                    <h4 className='sends'><ImTruck /> Envío A Todo el País</h4>
                    <h4 className={item.stock === 0 ? "stock-out" : "stock"}>Unidades Disponibles: {(item.stock === 1) ? "¡Último Disponible!" : item.stock}</h4>
                    <div className='flex-button-productdetail'>
                      <button className='button-car' style={item.stock === 0 ? { cursor: "not-allowed" } : { cursor: "pointer" }} disabled={item.stock === 0 ? true : false} onClick={() => crearProducto(item.nombre, item.descuento, item.imagen, item.id, item.descuento > 0 ? (precioValue * item.precio) - (parseInt(item.descuento) * (precioValue * item.precio) / 100) : parseInt(precioValue * item.precio))}>Agregar al Carrito</button>
                      <button className='button-wp'><a style={{ color: "white" }} target={"_blank"} href={`https://api.whatsapp.com/send?phone=+542612565651&text=¡Hola! me gustaría consultar cuando hay stock disponible para este producto: ${item.nombre}`}>Consultar Stock</a></button>
                    </div>
                    <button className='button-goback' onClick={() => history.goBack()}>Ir Atrás</button>
                  </div>
                </section>
                <div className="description_productdetail_container">
                  <h3>Caracteristicas De Producto</h3>
                  <p>{item.descripcion}</p>
                </div>
              </div>
            )
          })
        }
      </div>

    </>
  )
}

export default ProductDetails